import axios from 'axios';

const expertEmailTemplate = async (language, honorarium) => {
  const {
    data
  } = await axios({
    method: 'get',
    url: `/api/email-template/group/schedule_invite?hon=${honorarium}`,
    headers: {
      'Content-Type': 'application/json',
      authorization: window.localStorage.getItem('ngStorage-accessToken')
    }
  });
  let expertMessage;

  if (language) {
    expertMessage = data.filter(d => d.name.toLowerCase().includes(language))[0].content;
  }

  return {
    templates: data,
    expertMessage: expertMessage
  };
};

export default expertEmailTemplate;